import {useState} from 'react';
import {login} from '../lib/auth.js';
import './login.css';

/**
 * The sign-in screen: white page, the logo in black, underlined fields, a black button.
 * One centred column on every screen size. Styles are self-contained (login.css, all `lg-`
 * classes) so nothing in the app's global stylesheet can reach in. Monochrome like the
 * rest of Jabr.
 *
 * The failure message is the same whichever way it failed — wrong password, unknown
 * address, deactivated account. The server already refuses to distinguish them; saying
 * more here would hand back exactly the information it withholds. The ONE exception the
 * server makes is the lockout after eight attempts ("För många försök …"), which is
 * passed through: read as a wrong password, it would make the user try again and extend it.
 */
export default function Login({onSignedIn}) {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState(null);

	const submit = async e => {
		e.preventDefault();
		if (busy) return;
		setBusy(true);
		setError(null);
		try {
			await login(email.trim(), password);
			setPassword('');
			onSignedIn();
		} catch (err) {
			setError(err.code === 'invalid_grant' && err.message !== 'invalid_grant'
				? err.message
				: 'Fel e-post eller lösenord.');
		} finally {
			setBusy(false);
		}
	};

	return (
		<main className="lg-page">
			<div className="lg-col">
				<img className="lg-logo" src="/jabr-logo-dark.png" alt="Jabr" width="811" height="585" />
				<form className="lg-form" onSubmit={submit} aria-label="Logga in">
					<div className="lg-field">
						<label htmlFor="lg-email">E-post</label>
						<input id="lg-email" name="email" type="email" autoComplete="username" inputMode="email"
							autoCapitalize="none" spellCheck={false} required value={email}
							onChange={e => setEmail(e.target.value)} />
					</div>
					<div className="lg-field">
						<label htmlFor="lg-password">Lösenord</label>
						<input id="lg-password" name="password" type="password" autoComplete="current-password"
							required value={password} onChange={e => setPassword(e.target.value)} />
					</div>
					{error && <div className="lg-error" role="alert">{error}</div>}
					<button className="lg-submit" type="submit" disabled={busy || !email || !password} aria-busy={busy}>
						{busy ? 'Loggar in…' : 'Logga in'}
					</button>
				</form>
			</div>
		</main>
	);
}
